export const messages = {
  en:{
    meterWater: {
      queryConditions: 'Query Conditions',
      meterReadingInfo: 'Meter Reading Info',
      meterId: 'Meter ID',
      meterType: 'Meter Type',
      objectName: 'Object Name',
      preDegrees: 'Previous Degrees',
      curDegrees: 'Current Degrees',
      preReadingTime: 'Previous Reading Time',
      curReadingTime: 'Current Reading Time',
      createTime: 'Create Time',
      operation: 'Operation',
      readMeter: 'Read Meter',
      qrCodeMeter: 'QR Code Meter',
      import1: 'Import 1',
      import2: 'Import 2',
      selectMeterType: 'Please select meter type',
      inputMeterId: 'Please input meter ID',
      query: 'Query',
      reset: 'Reset',
      addMeterReading: 'Add Meter Reading',
      editMeterReading: 'Edit Meter Reading',
      confirmOperation: 'Please confirm your operation',
      confirmDeleteMeterReading: 'Confirm to delete meter reading',
      cancel: 'Cancel',
      confirmDelete: 'Confirm Delete',
      meterReadingImport: 'Meter Reading Import',
      meterReadingImport2: 'Meter Reading Import 2',
      feeType: 'Fee Type',
      selectFeeType: 'Please select fee type',
      feeItem: 'Fee Item',
      selectFeeItem: 'Please select fee item',
      feeItemTip: 'Note: Fee items with formula [(Current Degrees - Previous Degrees) * Price + Additional Fee]',
      meterTypeRequired: 'Please select meter type',
      building: 'Building',
      unit: 'Unit',
      room: 'Room',
      feeObject: 'Fee Object',
      inputRoom: 'Please input room',
      inputPreDegrees: 'Please input previous degrees',
      inputCurDegrees: 'Please input current degrees',
      selectPreReadingTime: 'Please select previous reading time',
      selectCurReadingTime: 'Please select current reading time',
      price: 'Price',
      inputPrice: 'Please input price',
      remark: 'Remark',
      inputRemark: 'Please input remark',
      unitTip: 'Note: Unit 0 means shop',
      save: 'Save',
      selectFile: 'Select File',
      fileRequired: 'Please select data file',
      downloadTemplate: 'Download Template',
      downloadTip: 'Please download',
      importTemplate: 'Import Template',
      prepareData: 'prepare data first, then upload to import',
      dynamicFeeTip: 'Used when fee item is dynamic fee',
      import: 'Import',
      meterQRCode: 'Meter QR Code',
      qrCode: 'QR Code',
      qrCodeTip: 'Please screenshot and print, paste it to the meter, meter reader can scan quickly',
      selectBuilding: 'Please select building',
      selectUnit: 'Please select unit',
      selectRoom: 'Please select room',
      feeTypeRequired: 'Please select fee type',
      feeItemRequired: 'Please select fee item',
      preDegreesRequired: 'Please input previous degrees',
      curDegreesRequired: 'Please input current degrees',
      preReadingTimeRequired: 'Please select previous reading time',
      curReadingTimeRequired: 'Please select current reading time',
      degreesFormatError: 'Degrees format error',
      degreesCompareError: 'Current degrees cannot be less than previous degrees',
      remarkMaxLength: 'Remark cannot exceed 500 characters',
      selectMeterTypeFirst: 'Please select meter type first',
      downloadStarted: 'Download started',
      importSuccess: 'Import success'
    }
  },
  zh:{
    meterWater: {
      queryConditions: '查询条件',
      meterReadingInfo: '抄表信息',
      meterId: '表ID',
      meterType: '表类型',
      objectName: '对象名称',
      preDegrees: '上期度数',
      curDegrees: '本期度数',
      preReadingTime: '上期读表时间',
      curReadingTime: '本期读表时间',
      createTime: '创建时间',
      operation: '操作',
      readMeter: '抄表',
      qrCodeMeter: '二维码抄表',
      import1: '抄表导入1',
      import2: '抄表导入2',
      selectMeterType: '请选择表类型',
      inputMeterId: '请输入表ID',
      query: '查询',
      reset: '重置',
      addMeterReading: '添加抄表',
      editMeterReading: '修改抄表',
      confirmOperation: '请确认您的操作',
      confirmDeleteMeterReading: '确定删除抄表',
      cancel: '点错了',
      confirmDelete: '确认删除',
      meterReadingImport: '抄表导入',
      meterReadingImport2: '抄表导入2',
      feeType: '费用类型',
      selectFeeType: '请选择费用类型',
      feeItem: '收费项目',
      selectFeeItem: '请选择收费项目',
      feeItemTip: '说明：显示公式为【(本期度数-上期度数)*单价+附加费】的费用项',
      meterTypeRequired: '请选择抄表类型',
      building: '楼栋',
      unit: '单元',
      room: '房屋',
      feeObject: '收费对象',
      inputRoom: '请填写房屋',
      inputPreDegrees: '请输入上期度数',
      inputCurDegrees: '请输入本期度数',
      selectPreReadingTime: '请选择上期读表时间',
      selectCurReadingTime: '请选择本期读表时间',
      price: '单价',
      inputPrice: '请输入单价',
      remark: '备注',
      inputRemark: '请输入备注',
      unitTip: '注：单元选择为0表示为商铺',
      save: '保存',
      selectFile: '选择文件',
      fileRequired: '请选择数据文件',
      downloadTemplate: '下载模板',
      downloadTip: '请先下载',
      importTemplate: '导入模板',
      prepareData: '准备数据后，上传导入',
      dynamicFeeTip: '当收费项目为动态费用时使用',
      import: '导入',
      meterQRCode: '抄表二维码',
      qrCode: '二维码',
      qrCodeTip: '请截图打印后，粘贴到电表处，抄表人员扫码快速抄表',
      selectBuilding: '请选择楼栋',
      selectUnit: '请选择单元',
      selectRoom: '请选择房屋',
      feeTypeRequired: '请选择费用类型',
      feeItemRequired: '请选择收费项目',
      preDegreesRequired: '请输入上期度数',
      curDegreesRequired: '请输入本期度数',
      preReadingTimeRequired: '请选择上期读表时间',
      curReadingTimeRequired: '请选择本期读表时间',
      degreesFormatError: '度数格式错误',
      degreesCompareError: '本期度数不能小于上期度数',
      remarkMaxLength: '备注不能超过500个字符',
      selectMeterTypeFirst: '请先选择抄表类型',
      downloadStarted: '下载已开始',
      importSuccess: '导入成功'
    }
  }
  
}